import {ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EntityService } from '../../entity.service';
import { AddNoteComponent } from '../add-note/add-note.component';

@Component({
  selector: 'app-note-events',
  templateUrl: './note-events.component.html',
  styleUrls: ['./note-events.component.scss']
})
export class NoteEventsComponent implements OnInit {

  constructor(private _matDialog: MatDialog, private _entityService: EntityService,public _changeDetectorRef:ChangeDetectorRef) { }
  notesLst=[]; searchText = '';
  @Input() cpmntData;
  enty_ky
  hndlr_nm
  loader
  ngOnInit(): void {
    this.enty_ky=this.cpmntData.enty_ky;
    this.hndlr_nm=this.cpmntData.hndlr_nm
    this.getNotes(this.enty_ky, this.hndlr_nm);
  }
  addNewNote(): void {
    this._matDialog.open(AddNoteComponent, {
      autoFocus: false,
      data: {
        note: {}
      }
    });
  }

  getNotes(id, hndlr_nm) {
    this.loader = true;
    this._entityService.get_note_hndlr(id, hndlr_nm).subscribe(res => {
      this.loader = false;
      if (res['status'] == 404) {
      } else if (res['status'] == 200) {
        this.notesLst = res['data'];
        this._changeDetectorRef.markForCheck();
      }
      else {
      }
    });
  }
  addNte()
  {
    const dialogRef = this._matDialog.open(AddNoteComponent, {
      data: {
        hndlr_nm: this.hndlr_nm,
        enty_ky:this.enty_ky
      }
    });

    dialogRef.afterClosed()
      .subscribe((result) => {
        this.getNotes(this.enty_ky, this.hndlr_nm)
      });
  }
  edtNte(note){
    const dialogRef = this._matDialog.open(AddNoteComponent, {
      data: {
        hndlr_nm: this.hndlr_nm,
        enty_ky:this.enty_ky,
        edit_in:1,
        editData:note
      }
    });

    dialogRef.afterClosed()
      .subscribe((result) => {
        this.getNotes(this.enty_ky, this.hndlr_nm)
      });
  }
  removeNote(note) {
    this._entityService.remove_note(note).subscribe((res: any) => {
      if (res.status == 200) {
        this._entityService.openSnackBar("Note removed successfully.", 'mat-primary'); this.getNotes(this.enty_ky, this.hndlr_nm);;
      }
      else { this._entityService.openSnackBar("Something went Wrong! Action denied.", 'amber'); this.getNotes(this.enty_ky, this.hndlr_nm);; }
    }, (err) => {
    })
  }
}
